export default __webpack_public_path__ + "static/media/Baseinsider_TIG.a07e625e.jpeg";